import { BehaviorSubject } from "rxjs";

export class ElementResizeObserverService {
    public static elementResize = new BehaviorSubject<boolean>(false);

    constructor() { }

    static resizeElement() {
        this.elementResize.next(true);
    }
}